import React, { useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../../../constants/pagination'
import { filterActiveOptions } from '../../../../../utils/app.utils'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { MenuItem, Typography } from '@mui/material'



// COMPONENT
import InputTextField from '../../../../../component/input/inputTextField'
import FilterSelect from '../../../../../component/select/filterSelect'
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import { ButtonContained } from '../../../../../component/mui-custom/MuiCustom'

// API
import { DepartMentApi } from '../../../../../api/department/department.api';
import { RolesApi } from '../../../../../api/roles/roles.api'
import { PositionsApi } from '../../../../../api/positions/positions.api'
import { EmployeesApi, updateEmployeesTypes } from '../../../../../api/employee/Employees.api';
import { swalError, swalSuccess } from '../../../../../component/notification/swal'
import { notificationSwal } from '../../../../../utils/notification.swal'
import CheckboxPermission from '../../../../../component/checkboxPermission/checkboxPermission'
import ButtonCustom from '../../../../../component/button/buttonCustom'

type Props = {
    employeeId: number;
    toggleModal: () => void;
    fetchData: () => void;
}
interface Action {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

interface Role {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

const EditUsers: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState<updateEmployeesTypes>({
        employeeFirstname: "",
        employeeLastname: "",
        email: "",
        idRole: 0,
        idDepartment: 0,
        idPosition: 0,
        tel: "",
        employeeStatus: t("STATUS.ACTIVE"),
        fax: "",
        title: ""
    })
    const [role, setRole] = useState<any>(null)
    const [department, setDepartment] = useState<any>(null)
    const [positions, setPositions] = useState<any>(null)
    const [departmentLampang, setDepartmentLampang] = useState<any[]>([])
    const [permission, setPermission] = useState<Role[]>([]);

    const handleGetRole = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await RolesApi.getRoles(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setRole(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetDepartment = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await DepartMentApi.getDepartments(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setDepartment(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleGetPositions = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await PositionsApi.getPosition(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                    setPositions(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleGetDetailEmployee = async () => {
        dispatch(setLoading())
        await EmployeesApi.getEmployeeDetail(props.employeeId)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const { email, employeeFirstname, employeeLastname, idDepartment, idRole, fax, idPosition, tel, title, permission } = res?.data?.result
                    setFormData((prev) => ({
                        ...prev,
                        email,
                        employeeFirstname,
                        employeeLastname,
                        idRole,
                        fax,
                        idDepartment,
                        idPosition,
                        tel,
                        title
                    }))
                    setPermission(permission)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault()
        dispatch(setLoading())
        await EmployeesApi.updateEmployee(Number(props.employeeId), { ...formData, permission: permission })
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(notificationSwal.success)
                    props.toggleModal()
                } else {
                    swalError(res.response?.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
                swalError(notificationSwal.error)
            })
            .finally(() => {
                dispatch(unsetLoading())
                props.fetchData()
            })
    }

    // หน่วยงาน DEPARTMENT
    const handleGetDepartmentLampang = async () => {
        await DepartMentApi.getDetailDepartment(1)
            .then(res => {
                // console.log(res.data?.result)
                setDepartmentLampang(res.data?.result?.departmentList)
            })
            .catch(error => {
                console.log(error)
            })
    }


    useEffect(() => {
        handleGetRole();
        handleGetDepartment();
        handleGetPositions();
        handleGetDepartmentLampang();
        handleGetDetailEmployee();
    }, [])

    const handleCheckboxChange = (node: any, checked: boolean) => {
        const updatedData = updateData([...permission], node, checked);
        setPermission(updatedData);
    };
    const updatePermit = (data: any, checked: boolean) => {
        return data?.map((item: any) => {
            const updatedItem = { ...item, permit: checked };
            if (item.actions && item.actions.length > 0) {
                updatedItem.actions = updatePermit(item.actions, checked);
            }
            return updatedItem;
        });
    };
    const updateData = (arr: any, targetNode: any, checked: boolean) => {
        return arr.map((node: any) => {
            if (node.code === targetNode.code) {
                return { ...node, permit: checked, actions: checked ? targetNode.actions : updatePermit(node.actions, false) };
            } else if (node.actions && node.actions.length > 0) {
                return { ...node, actions: updateData(node.actions, targetNode, checked) };

            }
            return node;
        });
    };

    const updateAll = (data: any) => {
        setPermission(updatePermit(data, true))
    }

    return (
        <form className='w-full' onSubmit={handleSubmit} >
            <div className='w-full flex flex-col gap-2'>
                <section className='grid grid-cols-12 gap-2 mt-5'>
                    <span className='col-span-12 md:col-span-3'>
                        <InputTextField
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, title: e.target.value })}
                            value={formData.title}
                            required
                            heading='คำนำหน้าชื่อ'
                            disabled
                        />
                    </span>
                    <span className='col-span-12 md:col-span-9'>
                        <InputTextField
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, employeeFirstname: e.target.value })}
                            value={`${formData.employeeFirstname} ${formData.employeeLastname}`}
                            required
                            heading='ชื่อ - นามสกุลพนักงาน'
                            disabled
                        />
                    </span>
                    {/* <span className='col-span-12 md:col-span-12'>
                        <InputTextField
                            value={formData.employeeLastname}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, employeeLastname: e.target.value })}
                            required
                            heading='นามสกุล'
                        />
                    </span> */}
                </section>
                <section className='w-full'>
                    <InputTextField
                        required
                        heading='email'
                        type='email'
                        value={formData.email}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, email: e.target.value })}
                        disabled
                    />
                </section>
                <section>
                    <FilterSelect
                        renderValue={() => formData.idRole === 0 ? "เลือกบทบาท" : role?.find((list: any) => list?.idRole === formData.idRole)?.roleName}
                        required
                        heading={t("บทบาท")}
                        label={t('STATUS.LABEL')}
                        selectId="select-role"
                        value={formData.idRole}
                        labelId="label-role"
                        onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setFormData({ ...formData, idRole: Number(e.target.value) })}
                        options={
                            filterActiveOptions(role, 'roleStatus', 'idRole', [formData.idRole]).map((list: any) => (
                                <MenuItem disabled={list?.roleStatus !== t("STATUS.ACTIVE")} key={list?.idRole} value={list?.idRole}>
                                    {list?.roleName}
                                </MenuItem>
                            ))
                        }
                    />
                </section>
                <section>
                    {departmentLampang && (
                        <FilterSelect
                            renderValue={() => formData.idDepartment === 0 ? "เลือกบทบาท" : department?.find((list: any) => list?.idDepartment === formData.idDepartment)?.departmentName}
                            required
                            heading={t("หน่วยงาน")}
                            label={t('STATUS.LABEL')}
                            selectId="select-department"
                            value={formData.idDepartment}
                            labelId="label-department"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setFormData({ ...formData, idDepartment: Number(e.target.value) })}
                            options={
                                departmentLampang && departmentLampang.map((list: any) => (
                                    <MenuItem disabled={list?.departmentStatus !== t("STATUS.ACTIVE")} key={list?.idDepartment} value={list?.idDepartment}>
                                        {list?.departmentName}
                                    </MenuItem>
                                ))
                            }
                            disabled
                        />
                    )}
                </section>
                <section>
                    <FilterSelect
                        required
                        heading={t("ตำแหน่ง")}
                        label={t('STATUS.LABEL')}
                        selectId="select-position"
                        value={formData.idPosition}
                        labelId="label-position"
                        onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setFormData({ ...formData, idPosition: Number(e.target.value) })}
                        options={
                            positions && positions?.map((list: any) => (
                                <MenuItem disabled={list?.positionStatus !== t("STATUS.ACTIVE")} key={list?.idPosition} value={list?.idPosition}>
                                    {list?.positionName}
                                </MenuItem>
                            ))
                        }
                        disabled
                    />
                </section>
                <section className='grid grid-cols-12 gap-2 mt-2'>
                    <span className='col-span-12 md:col-span-6'>
                        <InputTextField
                            required
                            heading='โทรศัพท์'
                            value={formData.tel}
                            type='text'
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, tel: e.target.value })}
                            disabled
                        />
                    </span>
                    <span className='col-span-12 md:col-span-6'>
                        <InputTextField
                            required
                            heading='โทรสาร'
                            value={formData.fax}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, fax: e.target.value })}
                            disabled
                        />
                    </span>
                </section>
                <section className='w-full'>
                    <FilterSelect
                        required
                        heading={t("ตำแหน่ง")}
                        label={t('STATUS.LABEL')}
                        selectId="select-position"
                        value={formData.employeeStatus}
                        labelId="label-position"
                        onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setFormData({ ...formData, employeeStatus: e.target.value })}
                        options={
                            [
                                <MenuItem value={t("STATUS.ACTIVE")}>
                                    <Typography className={`text-light_success`}> {t("STATUS.ACTIVE")}</Typography>
                                </MenuItem>
                                ,
                                <MenuItem value={t("STATUS.INACTIVE")}>
                                    <Typography className={`text-danger`}> {t("STATUS.INACTIVE")}</Typography>
                                </MenuItem>
                            ]
                        }
                    />
                </section>
                {permission?.length > 0 &&
                    <>
                        <Typography variant='h6' sx={{ margin: "22px 0px", fontWeight: '500' }}>{'กำหนดฟังก์ชัน'}</Typography>
                        <ButtonCustom textButton={'เลือกทั้งหมด'} onClick={() => updateAll(permission)} />
                    </>
                }
                {permission && permission?.map((list: any) => (
                    <CheckboxPermission
                        node={list}
                        onCheckboxChange={handleCheckboxChange}
                    />
                ))}
                <section className='flex justify-center items-center mt-3'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 100 }}
                    >
                        {t("BUTTON.SAVE")}
                    </ButtonContained>
                </section>
            </div>
        </form>
    )
}

export default EditUsers